import Validation from 'utils/validation.utils';

export const initialState = (state = {}) => {
  const {
    transactedAt = {
      value: '',
      disabled: false
    },
    remarks = {
      value: '',
      disabled: false
    },
    payee = {
      value: '',
      disabled: false
    },
    isGeneralJournal = {
      value: false,
      disabled: false
    }
  } = state;
  return {
    transactedAt: {
      name: 'transactedAt',
      validations: [Validation.required({ noMessage: true })],
      label: 'Document Date',
      required: true,
      ...transactedAt
    },
    remarks: {
      name: 'remarks',
      label: 'Remarks',
      required: false,
      ...remarks
    },
    payee: {
      name: 'payee',
      label: 'Payee',
      required: false,
      ...payee
    },
    isGeneralJournal: {
      name: 'isGeneralJournal',
      label: 'General Journal',
      ...isGeneralJournal
    }
  };
};
